import computed from 'flarum/common/utils/computed';
import Model from 'flarum/common/Model';
import type Discussion from 'flarum/common/models/Discussion';
import WikiLabel from 'flarum/common/models/WikiLabel';
import HeroTagLatestdata from 'flarum/common/models/HeroTagLatestdata';

export default class Tag extends Model {
  pkgId() {
    return Model.attribute<number>('pkgId').call(this);
  }
  name() {
    return Model.attribute<string>('name').call(this);
  }
  subName() {
    return Model.attribute<string>('subName').call(this);
  }
  subImg() {
    return Model.attribute<string>('subImg').call(this);
  }
  slug() {
    return Model.attribute<string>('slug').call(this);
  }
  mainImgUrl() {
    return Model.attribute<string>('mainImgUrl').call(this);
  }
  mainImgJumpUrl() {
    return Model.attribute<string>('mainImgJumpUrl').call(this);
  }
  sortCount() {
    return Model.attribute<number>('sortCount').call(this);
  }
  skyspirePageSize() {
    return Model.attribute<number>('skyspirePageSize').call(this);
  }
  isAllTag() {
    return Model.attribute<boolean>('isAllTag').call(this);
  }
  description() {
    return Model.attribute<string | null>('description').call(this);
  }

  color() {
    return Model.attribute<string | null>('color').call(this);
  }
  backgroundUrl() {
    return Model.attribute<string | null>('backgroundUrl').call(this);
  }
  backgroundMode() {
    return Model.attribute<string | null>('backgroundMode').call(this);
  }
  icon() {
    return Model.attribute<string | null>('icon').call(this);
  }

  position() {
    return Model.attribute<number | null>('position').call(this);
  }
  parent() {
    return Model.hasOne<Tag | null>('parent').call(this);
  }
  children() {
    return Model.hasMany<Tag>('children').call(this);
  }
  defaultSort() {
    return Model.attribute<string | null>('defaultSort').call(this);
  }
  isChild() {
    return Model.attribute<boolean>('isChild').call(this);
  }
  isHidden() {
    return Model.attribute<boolean>('isHidden').call(this);
  }

  discussionCount() {
    return Model.attribute<number>('discussionCount').call(this);
  }
  lastPostedAt() {
    return Model.attribute('lastPostedAt', Model.transformDate).call(this);
  }
  lastPostedDiscussion() {
    return Model.hasOne<Discussion | null>('lastPostedDiscussion').call(this);
  }
  wikiHeroDetailDiscussion() {
    return Model.hasOne<Discussion | null>('wikiHeroDetailDiscussion').call(this);
  }
  wikiHeroDetailDiscussionId() {
    return Model.attribute<number>('wikiHeroDetailDiscussionId').call(this);
  }

  isRestricted() {
    return Model.attribute<boolean>('isRestricted').call(this);
  }
  
  canStartDiscussion() {
    return Model.attribute<boolean>('canStartDiscussion').call(this);
  }
  canAddToDiscussion() {
    return Model.attribute<boolean>('canAddToDiscussion').call(this);
  }

  isPrimary() {
    return computed<boolean, this>('position', 'parent', (position, parent) => position !== null && parent === false).call(this);
  }

  isNotBasic() {
    return Model.attribute<boolean>('isNotBasic').call(this);
  }

  isAdminLook() {
    return Model.attribute<boolean>('isAdminLook').call(this);
  }

  mainHeroNickname() {
    return Model.attribute<string>('mainHeroNickname').call(this);
  }

  mainHeroName() {
    return Model.attribute<string>('mainHeroName').call(this);
  }

  viewsCount() {
    return Model.attribute<number>('viewsCount').call(this);
  }

  isWikiHero() {
    return Model.attribute<boolean>('isWikiHero').call(this);
  }

  wikiLabel() {
    return Model.hasMany<WikiLabel>('wikiLabel').call(this);
  }

  heroTagLatestdata() {
    return Model.hasOne<HeroTagLatestdata>('heroTagLatestdata').call(this);
  }
}
